module.exports = __webpack_public_path__ + "static/media/laxmirajmokuf4.c6ce9d4c.png";